import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutHalfFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutHalfFull"><Path d="M3 11.25V3H21V11.25L3 11.25Z" fill="currentColor"/><Path d="M3 12.75V21H21V12.75L3 12.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutHalfFull;
